// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Heading from '../../../../../../common/atoms/Heading';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/FormPageHeading.styles';
import Anchor from '../../../../../../common/atoms/Anchor';

export const FormPageHeading = ({
  className,
  heading,
  showCta,
  toPathUrl,
  asPathUrl,
  labelValue,
  prev,
  next,
  showCarouselAction,
  ...otherProps
}) => {
  return (
    <Heading component="h2" variant="h6" className={className} tabIndex="-1" {...otherProps}>
      {heading}
      {showCta && (
        <div>
          {' '}
          <Anchor
            className="heading-cta"
            to={toPathUrl}
            asPath={asPathUrl}
            target={'_self'}
            fromBIA
          >
            {labelValue}
          </Anchor>
        </div>
      )}
    </Heading>
  );
};

FormPageHeading.propTypes = {
  className: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
};

export default withStyles(FormPageHeading, styles);
